export interface Testimonial {
  image: string
  alt: string
}

export const testimonials: Testimonial[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/sSJg1s4cyEEUpnwoQpuFYU/ChatGPT_Image_10_sept_2026,_16_05_00.png',
    alt: 'Mensaje de Mariana López contando que empezó por el living y el dormitorio y ahora siente su casa más agradable',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/gfczgXhXYTsSyQHvWatcEc/ChatGPT_Image_10_sept_2026,_16_15_22.png',
    alt: 'Mensaje de Lorena Vidal contando cómo separó el trabajo del dormitorio y ahora se siente un lugar para descansar',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/trVgkdhh41tdAbLmcnWoaU/ChatGPT_Image_10_sept_2026,_16_10_34.png',
    alt: 'Mensaje de Marcela Quiroga contando que con el Mapa Bagua sobre el plano encontró zonas que no usaba',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/qscvdtZYreB5wzgtaVywt7/ChatGPT_Image_10_sept_2026,_16_18_31.png',
    alt: 'Mensaje de una lectora que trabaja desde casa y cambió la posición de su escritorio',
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/foNup3bgT6YVbUaxQvgXXQ/ChatGPT_Image_10_sept_2026,_16_20_19.png',
    alt: 'Mensaje de una lectora que movió la cama y sacó cosas de abajo y siente el dormitorio más liviano',
  },
]
